import ApiService from "@/services/api.service";
import { handleVuexError, handleVuexSuccess } from "@/js/errorHandler";

const state = {
    globalLoading: false,
    error: {},
};

const getters = {
    error: (state) => state.error,
    globalLoading: (state) => state.globalLoading,
};

const actions = {
    DOWNLOAD_TEMPLATE({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            commit("setGlobalLoading", true);
            ApiService.generate("MailMassiveUI/download-template")
                .then((res) => {
                    handleVuexSuccess({ commit, dispatch, state: this.state }, "Template scaricato con successo", "setGlobalLoading");
                    resolve(res);
                })
                .catch((error) => {
                    handleVuexError({ commit, dispatch, state: this.state }, error, "Errore nel download del template", "setGlobalLoading");
                    reject(error);
                });
        });
    },

    UPLOAD_TEMPLATE(context, formData) {
        return new Promise((resolve, reject) => {
            context.commit("setGlobalLoading", true);
            ApiService.postFormData("MailMassiveUI/upload-template", formData)
                .then((res) => {
                    context.commit("setGlobalLoading", false);
                    if (res.data?.status === "error") {
                        context.commit("setError", res.data.message);
                        setTimeout(() => context.commit("setError", {}), 5000);
                        reject(res.data);
                    } else {
                        resolve(res);
                    }
                })
                .catch(({ response }) => {
                    context.commit("setGlobalLoading", false);
                    const errorMsg = response?.data?.message || response?.data?.Message || "Errore nel caricamento del template";
                    context.commit("setError", errorMsg);
                    setTimeout(() => context.commit("setError", {}), 5000);
                    reject(response);
                });
        });
    },

    UPLOAD_ATTACHMENTS(context, formData) {
        return new Promise((resolve, reject) => {
            context.commit("setGlobalLoading", true);
            ApiService.postFormData("MailMassiveUI/upload-attachments", formData)
                .then((res) => {
                    context.commit("setGlobalLoading", false);
                    if (res.data?.status === "error") {
                        context.commit("setError", res.data.message);
                        setTimeout(() => context.commit("setError", {}), 5000);
                        reject(res.data);
                    } else {
                        resolve(res);
                    }
                })
                .catch(({ response }) => {
                    context.commit("setGlobalLoading", false);
                    const errorMsg = response?.data?.message || response?.data?.Message || "Errore nel caricamento degli allegati";
                    context.commit("setError", errorMsg);
                    setTimeout(() => context.commit("setError", {}), 5000);
                    reject(response);
                });
        });
    },

    GET_PREVIEW(context) {
        return new Promise((resolve, reject) => {
            context.commit("setGlobalLoading", true);
            ApiService.get("MailMassiveUI/preview")
                .then((res) => {
                    context.commit("setGlobalLoading", false);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit("setGlobalLoading", false);
                    const errorMsg = response?.data?.message || response?.data?.Message || "Errore nel caricamento del preview";
                    context.commit("setError", errorMsg);
                    setTimeout(() => context.commit("setError", {}), 5000);
                    reject(response);
                });
        });
    },

    SEND_TO_SERVER(context, requestData) {
        return new Promise((resolve, reject) => {
            context.commit("setGlobalLoading", true);
            ApiService.post("MailMassiveUI/send-to-server", requestData)
                .then((res) => {
                    context.commit("setGlobalLoading", false);
                    if (res.data?.status === "error") {
                        context.commit("setError", res.data.message);
                        setTimeout(() => context.commit("setError", {}), 5000);
                        reject(res.data);
                    } else {
                        resolve(res);
                    }
                })
                .catch(({ response }) => {
                    context.commit("setGlobalLoading", false);
                    const errorMsg = response?.data?.message || response?.data?.Message || "Errore nell'invio massivo";
                    context.commit("setError", errorMsg);
                    setTimeout(() => context.commit("setError", {}), 5000);
                    reject(response);
                });
        });
    },

    CLEAR_DATA(context) {
        return new Promise((resolve, reject) => {
            ApiService.deleteResource("MailMassiveUI/clear-data")
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    const errorMsg = response?.data?.message || response?.data?.Message || "Errore nella pulizia dei dati";
                    context.commit("setError", errorMsg);
                    setTimeout(() => context.commit("setError", {}), 5000);
                    reject(response);
                });
        });
    },

    SET_ERROR(context, error) {
        context.commit("setError", error);
    },
};

const mutations = {
    setGlobalLoading(state, loading) {
        state.globalLoading = loading;
    },

    setError(state, error) {
        state.error = error;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
